var _mask, _mask2, _mask3, _mask4, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 15,
    viewBox: "0 0 20 15",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 15,
    maskUnits: "userSpaceOnUse",
    width: 20,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v15h-20z",
    fill: "#fff"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    height: 15,
    maskUnits: "userSpaceOnUse",
    width: 20,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m0 0v15h20v-15z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    height: 15,
    maskUnits: "userSpaceOnUse",
    width: 20,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v15h-20z",
    fill: "#fff"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12.3611-1.25h-4.72221v6.25h-8.87168v5h8.87168v6.25h4.72221v-6.25h8.9061v-5h-8.9061z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m0 0v15h20v-15z",
    fill: "#2e42a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.22693 13.9284 4.40106 1.8613 17.92577-13.76604 2.3215-2.765926-4.7063-.622094-7.3115 5.93217-5.88504 3.99689z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1.62439 15.2325 2.242135 1.0801 20.970055-17.311816h-3.1483z",
    fill: "#f50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.2271 13.9284-4.4011 1.8613-17.9257791-13.76604-2.3214609-2.765926 4.7063-.622094 7.3115 5.93217 5.88504 3.99689z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.0769 14.8643-2.2421 1.0802-8.9293-7.41214-2.64731-.82814-10.90278-8.436993h3.148222l10.896668 8.236743 2.8944.99302z",
    fill: "#f50100"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12.3611-1.25h-4.72221v6.25h-8.87168v5h8.87168v6.25h4.72221v-6.25h8.9061v-5h-8.9061z",
    fill: "#f50100",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.63889-1.25v-1.25h-1.25v1.25zm4.72221 0h1.25v-1.25h-1.25zm-4.72221 6.25v1.25h1.25v-1.25zm-8.87168 0v-1.25h-1.25v1.25zm0 5h-1.25v1.25h1.25zm8.87168 0h1.25v-1.25h-1.25zm0 6.25h-1.25v1.25h1.25zm4.72221 0v1.25h1.25v-1.25zm0-6.25v-1.25h-1.25v1.25zm8.9061 0v1.25h1.25v-1.25zm0-5h1.25v-1.25h-1.25zm-8.9061 0h-1.25v1.25h1.25zm-4.72221-5h4.72221v-2.5h-4.72221zm1.25 5v-6.25h-2.5v6.25zm-10.12168 1.25h8.87168v-2.5h-8.87168zm1.2500019 3.75v-5h-2.5000019v5zm7.6216781-1.25h-8.87168v2.5h8.87168zm1.25 7.5v-6.25h-2.5v6.25zm3.47221-1.25h-4.72221v2.5h4.72221zm-1.25-5v6.25h2.5v-6.25zm10.1561-1.25h-8.9061v2.5h8.9061zm-1.25-3.75v5h2.5v-5zm-7.6561 1.25h8.9061v-2.5h-8.9061zm-1.25-7.5v6.25h2.5v-6.25z",
    fill: "#fff",
    mask: "url(#d)"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 1h18v-2h-18zm18 0v13h2v-13zm0 13h-18v2h18zm-18 0v-13h-2v13zm0 0h-2c0 1.1046.895431 2 2 2zm18 0v2c1.1046 0 2-.8954 2-2zm0-13h2c0-1.10457-.8954-2-2-2zm-18-2c-1.104569 0-2 .89543-2 2h2z",
    fill: "#000",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEng);
export default __webpack_public_path__ + "static/media/eng.2d973e7d4caf3038a97f3f9b38947c7a.svg";
export { ForwardRef as ReactComponent };